import { locHtml } from './locHtml';
import { makeSplashHeader } from './SplashHeader';

const busySplashHtml = locHtml((t) => `
<div class="new-quote-container centered">
  <div class="splash-icon">⏳</div>
  <div class="splash-header">
    <h1>${t("splash.busy.title")}</h1>
    <div class="quote">
      ${t("splash.busy.text")}
    </div>
  </div>
</div> 
`);

const busySplashElement = {
  name: 'busy-splash',
  type: 'html',
  html: busySplashHtml,
}

const BusySplashHeader = makeSplashHeader("splash.headers.busy");

export {
  busySplashElement,
  BusySplashHeader
}
